import { AxiosResponse } from 'axios'
import { RequestREAD, RequestGST, RequestCDU } from 'services/Instances'

export const JobsService = () => {
  const path = 'Job'

  const alterarEmailCorpo = async (idHangfireJob: string, requestObj: any) =>
    RequestCDU.patch(
      `${path}/AlterarEmailCorpo?IdHangfireJob=${idHangfireJob}`,
      requestObj
    )

  const alterarEmails = async (idHangfireJob: string, requestObj: any) =>
    RequestCDU.patch(
      `${path}/AlterarEmails?IdHangfireJob=${idHangfireJob}`,
      requestObj
    )

  const alterarDataPlanejamento = async (
    request: IJobAlterarDataPlanejamento
  ) =>
    RequestCDU.patch(
      `${path}/AlterarDataPlanejamento?idHangfireJob=${request.idHangfireJob}`,
      request
    )

  const alterarRecorrencia = async (idHangfireJob: string, requestObj: any) =>
    RequestCDU.patch(
      `${path}/AlterarRecorrencia?IdHangfireJob=${idHangfireJob}`,
      requestObj
    )

  const getAll = async (): Promise<AxiosResponse<IGetAllJobsResponse[]>> =>
    await RequestREAD.get(`${path}?TxTipoContexto=GST`)

  const suspender = async (idHangfireJob: string, flAtivo: boolean) =>
    await RequestCDU.patch(
      `${path}/AlterarEstado?IdHangfireJob=${idHangfireJob}&FlAtivo=${flAtivo}`
    )

  const deleteJob = async (idHangfireJob: string) =>
    await RequestCDU.delete(`${path}/Excluir?IdHangfireJob=${idHangfireJob}`)

  return {
    alterarDataPlanejamento,
    alterarEmailCorpo,
    alterarEmails,
    alterarRecorrencia,
    deleteJob,
    getAll,
    suspender
  }
}

export interface JobInfo {
  idJobInfo?: number
  txTipoRecorrencia?: string
  dtPlanejamentoInicio?: Date | string
  dtPlanejamentoFim?: Date | string
  nuHoraRecorrencia?: string
  nuMinutoRecorrencia?: string
  txDiasSemanaRecorrencia?: string
  nuDiasRecorrencia?: string
  idJob?: number
}

export interface JobAlterarRecorrencia {
  tipoRecorrencia: string
  txDiasSemanaRecorrencia?: string
  nuDiasRecorrencia?: string
  listaHoras?: ListaHoras[]
}

export interface ListaHoras {
  idJobRecorrencia?: number
  horaRecorrencia: string
}

export interface JobEmail {
  idJobEmail: number
  txEmailDestinatario: string
  nmDestinatario: string
  idJob: number
}

export interface IJobAlterarDataPlanejamento {
  dtInicioPlanejamento: Date
  dtFimPlanejamento: Date
  idHangfireJob: string
}

export interface JobRecorrencia {
  idJobRecorrencia: number
  hrRecorrencia: string
  idJob: number
}

export interface IGetAllJobsParams {
  pageNumber?: number
  pageSize?: number
}

export interface IGetAllJobsResponse {
  idJob: number
  idHangfireJob: string
  nmJob: string
  jobInfo: JobInfo
  jobEmails: JobEmail[]
  jobRecorrencias: JobRecorrencia[]
  flAtivo: boolean
  flExcluido: boolean
}

export interface ILogEmailFilter {
  nmFornecedor: string
  TxEmailResponsavel: string
  DtEnvioInicio: string
  DtEnvioFim: string
  CdMatriculaContraparte: string
  NmContraparte: string
  NmTipoJOB: string
  PageNumber: number
  PageSize: number
}

export interface GrupoEmail {
  grupoEmailId?: number
  descricao?: string
  nome?: string
  ativo?: boolean
  grupoDeEmailItem?: any
}

export interface Suspender {
  jobId?: number
  ativo?: boolean
}
